module.exports = __webpack_public_path__ + "img/icon_top_knock_pre.ae0672c9.png";